module.exports = "/_next/static/images/reddit-2fe2ce40f241f7835c2d239f486b8c03.png";